import jwt_decode from 'jwt-decode';

import AirportTransferManualBookingV1 from './AirportTransfer1';
import AirportTransferBookingV2 from './AirportTransfer2';

export default function AirportTransfer() {
  const parsedUser = jwt_decode(JSON.parse(window.localStorage.getItem('authUser'))?.token)?.user_id;

  console.log('parsedUser', parsedUser);

  return (
    <>
      {/* {[`2e7569b8-7b3c-4ec6-99cc-d2bd38e40f84`, `a662e132-d413-40a3-a87d-2eb94408973b`]?.includes(parsedUser) ? ( */}
      {/* {[]?.includes(parsedUser) ? <AirportTransferBookingV2 /> : <AirportTransferManualBookingV1 />} */}
      <AirportTransferBookingV2 />
    </>
  );
}
